import { DocumentNode } from 'graphql';
import { Client, createClient, defaultExchanges } from 'urql';

import APP_CONFIG from '@/app.config';
import User, { ChimeraMeUser } from '@/models/user/user.model';
import { ENDPOINTS } from '@/settings/endpoints';

import SentryClient from './sentry';

function getChimeraClient(): Client | undefined {
  const url: string | undefined = ENDPOINTS.chimera;

  if (!url) {
    SentryClient.captureError(new Error('Chimera Endpoint is undefined'));
    return undefined;
  }

  const chimeraClient = createClient({
    url,
    fetchOptions: () => {
      const token: string | undefined = User.getUserToken();
      return {
        headers: { authorization: token ? `Bearer ${token}` : '' },
      };
    },
    exchanges: defaultExchanges,
  });

  return chimeraClient;
}

async function chimeraQuery(
  query: string | DocumentNode,
  variables?: Record<string, unknown> | undefined,
): Promise<any> {
  const chimeraClient = getChimeraClient();
  const result = await chimeraClient?.query(query, variables).toPromise();
  return result;
}

function getUserPictureUrl(user: ChimeraMeUser | undefined): string {
  const chimeraPictureUrl = String(process.env.NEXT_PUBLIC_PASSEPARTOUT_CHIMERA_PICTURE_DOMAIN);
  const passepartoutPictureUrl = String(process.env.NEXT_PUBLIC_PASSEPARTOUT_PICTURE_DOMAIN);
  return (
    user?.picture?.replace(chimeraPictureUrl, passepartoutPictureUrl) ||
    `https://api.dicebear.com/7.x/initials/svg?seed=${
      user?.name || APP_CONFIG.conventions.DEFAULT_USER_NAME
    }`
  );
}

export { chimeraQuery, getUserPictureUrl };
